import React from 'react';
import { Container, Row, Image } from 'react-bootstrap';

function AboutPage() {
    return (
      <Container
      fluid
      className="p-0 d-flex justify-content-center align-items-center"
      style={{ height: '100vh', width: '50vw' }}
    >
          <Row>
            <Image
              src="/images/tomte_text_blue.svg"
              alt="Large Background"
              className="img-fluid"
          style={{ maxHeight: '100%', maxWidth: '100%' }}
            />
            <h2 style={{ marginTop: '20px', textAlign: 'center' }}>Shhh... the tomte are working.</h2>
          </Row>
        </Container>
      );
    }


export default AboutPage;